// import RegistrationModule from '@/store/modules/registration.module';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const storeOptions = {
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
};

export default new Vuex.Store(storeOptions);
